module.exports = __webpack_public_path__ + "img/Elena_Mateo.cd20b05a.jpg";